const BookmarkImages = [
	{
		ID: 1,
		img: require('./1.jpg'),
	},
	{
		ID: 2,
		img: require('./2.jpg'),
	},
	{
		ID: 3,
		img: require('./3.jpg'),
	},
	{
		ID: 4,
		img: require('./4.jpg'),
	},
	{
		ID: 5,
		img: require('./5.jpg'),
	},
	{
		ID: 6,
		img: require('./6.jpg'),
	},
	{
		ID: 7,
		img: require('./7.jpg'),
	},
	{
		ID: 10,
		img: require('./10.jpg'),
	},
	{
		ID: 12,
		img: require('./12.jpg'),
	},
	{
		ID: 13,
		img: require('./13.jpg'),
	},
	{
		ID: 15,
		img: require('./15.jpg'),
	},
	// {
	//     ID: 21,
	//     img: require('./21.jpg'),
	// },
];

export default BookmarkImages;
